import { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { useRouter } from "next/router";
import { disableFooter, enableFooter } from "@app/store/layoutSlice";
import { DEFAULT_PRECISION } from "../constants";
import { getPrecision } from "../lib";

export const useMapMode = () => {
    const router = useRouter();
    const dispatch = useDispatch();

    const [mapListMode, setMapListMode] = useState(false);
    const [newBounds, setNewBounds] = useState<number[][]>();
    const [newZoom, setNewZoom] = useState<number>(DEFAULT_PRECISION);

    const mapQuery = router.query?.mapView;
    const [mapMode, setMapMode] = useState(!!mapQuery);

    const formattedCoordinates = useMemo(() => {
        if (newBounds) {
            return {
                bottomLeft: `${newBounds[0][0]};${newBounds[0][1]}`,
                topRight: `${newBounds[1][0]};${newBounds[1][1]}`
            };
        }
        return { bottomLeft: undefined, topRight: undefined };
    }, [newBounds]);

    useEffect(() => {
        const mapQuery = router.query?.mapView;
        setMapMode(!!mapQuery);
    }, [router.query]);

    useEffect(() => {
        if (mapMode) {
            dispatch(disableFooter());
            setMapListMode(true);
        } else {
            dispatch(enableFooter());
        }

        return () => {
            dispatch(enableFooter());
        };
    }, [mapMode, dispatch]);

    const handleDisableMapListMode = () => {
        if (!mapMode) {
            setMapListMode(false);
        }
    };

    const handleBoundsChange = (bounds: number[][], zoom = DEFAULT_PRECISION) => {
        const precision = getPrecision(zoom);
        setNewBounds(bounds);
        setNewZoom(precision);
    };

    const handleViewModeChange = (isMap: boolean) => {
        setMapMode(isMap);
    };

    return {
        mapMode,
        mapListMode,
        newBounds,
        newZoom,
        formattedCoordinates,
        setMapMode,
        handleDisableMapListMode,
        handleBoundsChange,
        handleViewModeChange
    };
};